import { render, staticRenderFns } from "./EcommerceStatistics.vue?vue&type=template&id=ffa143d8&scoped=true"
import script from "./EcommerceStatistics.vue?vue&type=script&lang=js"
export * from "./EcommerceStatistics.vue?vue&type=script&lang=js"
import style0 from "./EcommerceStatistics.vue?vue&type=style&index=0&id=ffa143d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa143d8",
  null
  
)

export default component.exports